<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title">{{ modalTitle }}</h2>
  </div>

  <form [formGroup]="formGroup">
    <div class="modal-body">
      <div class="field">
        <gains-input label="Chat Name" type="text" placeholder="Chat name" formControlName="chatName" [required]="true" />
      </div>
    </div>
  </form>

  <div class="modal-footer">
    <button class="footer-btns" nz-button nzType="default" (click)="onCancel()">Cancel</button>
    <button class="footer-btns" nz-button nzType="primary" [disabled]="!this.formGroup.valid" (click)="onSave()">Save</button>
  </div>
</div>
